<template>
  <BasicLayout :left='left' :middle='middle' :right='right'>
    <template v-slot:left_view>
      <NeTree :observeType='1'></NeTree>
    </template>
    <template v-slot:right_view>
      <ObserveTaskList :observeType='1'></ObserveTaskList>
    </template>
  </BasicLayout>
</template>
<script>
import BasicLayout from '../../layouts/BasicLayout';
import NeTree from '../../components/observeconfig/neTree/NeTree';
import ObserveTaskList from '../../components/observeconfig/observeTask/ObserveTaskList';

export default {
  name: 'FailObservePage',
  components: {
    BasicLayout,
    NeTree,
    ObserveTaskList
  },
  data() {
    return {
      left: {
        show: true,
        name: this.$t('Track.resourcesList')
      },
      middle: {
        show: false,
        name: ''
      },
      right: {
        show: true,
        crumb: `${this.$t('Observe.observeManage')}/${this.$t('Observe.failTrack')}`
      }
    };
  }
};
</script>